import * as React from 'react';
import { Drawer, Button, CircularProgress } from '@mui/material';
import { H4 } from '../../themes/typography';

export default function DrawerOverlay({
    open,
    onClose,
    onClick,
    disabled,
    children,
    drawerTitle = 'Ready to go live?',
    primaryButtonText = 'Publish',
    secondaryButtonText = 'Not now',
    loading = false,
    shouldShowPrimaryButton = true
}) {
    return (
        <React.Fragment>
            <Drawer anchor="right" open={open} onClose={onClose}>
                <div style={styles.drawerBox}>
                    <div style={styles.drawerWrapper}>
                        <div style={styles.drawerTitleArea}>
                            <H4 color="#f8a21e">{drawerTitle}</H4>
                        </div>
                        <div style={styles.drawerChildrenArea}>{children}</div>

                        <div style={styles.drawerActionArea}>
                            <Button variant="text" fullWidth onClick={onClose}>
                                {secondaryButtonText}
                            </Button>

                            {shouldShowPrimaryButton && (
                                <Button
                                    variant="main"
                                    fullWidth
                                    disabled={disabled || loading}
                                    onClick={onClick}
                                >
                                    {primaryButtonText}{' '}
                                    {loading && (
                                        <CircularProgress
                                            size={20}
                                            sx={{
                                                marginLeft: '0.75rem',
                                                color: 'var(--primary-color)'
                                            }}
                                        />
                                    )}
                                </Button>
                            )}
                        </div>

                    </div>
                </div>
            </Drawer>
        </React.Fragment>
    );
}

const styles = {
    drawerBox: {
        width: '100%',
        height: '100%',
        padding: '1rem'
    },
    drawerWrapper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
    },
    drawerActionArea: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '1rem',
        borderTop: '1px solid rgba(153,166,173,0.25)',
        paddingTop: '0.75rem'
    },
    drawerTitleArea: {
        width: '100%',
        borderBottom: '1px solid rgba(153,166,173,0.25)',
        paddingBottom: '0.5rem'
    },
    drawerChildrenArea: {
        width: '100%',
        flex: '1 1 auto', // Takes remaining height
        overflow: 'auto', // Allows scrolling if content is too long
        // border: '1px solid #f8a21e',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-start'
    }
};
